import { c as _c } from "react/compiler-runtime";
// Server-side Markdown renderer for database posts
import MarkdownIt from 'markdown-it';
function generateHeadingId(text: string): string {
  return text.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/(^-|-$)/g, '');
}
const md = new MarkdownIt({
  html: true,
  linkify: true,
  breaks: true
});

// Custom renderer for headings with IDs
md.renderer.rules.heading_open = function (tokens, idx) {
  const token = tokens[idx];
  const level = token.markup.length;
  const nextToken = tokens[idx + 1];
  if (nextToken && nextToken.type === 'inline') {
    const headingText = nextToken.content;
    const id = generateHeadingId(headingText);
    return `<h${level} id="${id}">`;
  }
  return `<h${level}>`;
};

// Custom renderer for links with nofollow
md.renderer.rules.link_open = function (tokens, idx, options, env, renderer) {
  const token = tokens[idx];
  const hrefIndex = token.attrIndex('href');
  if (hrefIndex >= 0) {
    const href = token.attrGet('href');
    // Add nofollow to all links
    token.attrSet('rel', 'nofollow');
    // Optionally add target="_blank" for external links
    if (href && (href.startsWith('http://') || href.startsWith('https://'))) {
      token.attrSet('target', '_blank');
    }
  }
  return renderer.renderToken(tokens, idx, options);
};
interface MarkdownContentProps {
  content: string;
}

/**
 * Server-side Markdown renderer for database posts
 * This component uses markdown-it which works in all environments including Edge Runtime
 */
export function MarkdownContent(t0) {
  const $ = _c(4);
  const {
    content
  } = t0;
  let t1;
  if ($[0] !== content) {
    t1 = content ? md.render(content) : "";
    $[0] = content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const html = t1;
  let t2;
  if ($[2] !== html) {
    t2 = <div className="markdown-body" dangerouslySetInnerHTML={{
      __html: html
    }} />;
    $[2] = html;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}